export default {
  title: 'Overview',
  table_title: 'Reservations',
  filters: {
    card_title: 'Filters',
    today: 'Today',
    upcoming: 'Upcoming',
    past: 'Past',
    all: 'All',
    all_dates: 'All time',
    pending: 'Pending Confirmation',
    canceled: 'Canceled',
    removed: 'Removed',
    date_label: 'Date:',
    status_label: 'Status:',
    source_label: 'Source:',
    source_website: 'Website',
    source_google: 'Google',
    search_label: 'Search:',
    search_placeholder: 'Search by first or last name',
    custom_date_tooltip: 'Pick a specific date',
    active_label: 'Active filters:',
    clear_all: 'Clear all',
  },
  tooltips: {
    total_reservations: 'Total reservations',
    total_guests: 'Total guests',
    refresh: 'Refresh',
  },
  empty: {
    default: 'No reservations yet.',
    filtered: 'No reservations match your filters.',
  },
  fields: {
    company: 'Restaurant',
    datetime: 'Date / time',
    customer: 'Customer',
    source: 'Source',
    guests: 'Guests',
    status: 'Status',
    created_at: 'Created at',
  },
  status: {
    confirmed: 'Confirmed',
    pending: 'Waiting for approval',
    canceled: 'Canceled',
    rejected: 'Rejected',
    removed: 'Removed',
  },
  buttons: {
    details: 'Details',
    add_reservation: 'Add Reservation',
  },
  toasts: {
    failed_to_load_data: 'Failed to load data',
  },
};
